//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class TodoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    load(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/Load";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoad(_response);
        });
    }

    protected processLoad(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bookmarks(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmarks(_response);
        });
    }

    protected processBookmarks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfPages(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/RenderPdfPages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPdfPages(_response);
        });
    }

    protected processRenderPdfPages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderThumbnailImages(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/RenderThumbnailImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderThumbnailImages(_response);
        });
    }

    protected processRenderThumbnailImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderPdfTexts(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/RenderPdfTexts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPdfTexts(_response);
        });
    }

    protected processRenderPdfTexts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renderAnnotationComments(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/RenderAnnotationComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderAnnotationComments(_response);
        });
    }

    protected processRenderAnnotationComments(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unload(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/Unload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnload(_response);
        });
    }

    protected processUnload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    download(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/PDF/Download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printImages(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/PrintImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintImages(_response);
        });
    }

    protected processPrintImages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAnnotations(id: string, body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/PDF/{id}/ExportAnnotations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAnnotations(_response);
        });
    }

    protected processExportAnnotations(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importAnnotations(body: { [key: string]: string; } | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PDF/ImportAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportAnnotations(_response);
        });
    }

    protected processImportAnnotations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTodos(  cancelToken?: CancelToken | undefined): Promise<GetTodosResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/getTodos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodos(_response);
        });
    }

    protected processGetTodos(response: AxiosResponse): Promise<GetTodosResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGanttTodos(  cancelToken?: CancelToken | undefined): Promise<GetTodosForGanttResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/getGanttTodos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGanttTodos(_response);
        });
    }

    protected processGetGanttTodos(response: AxiosResponse): Promise<GetTodosForGanttResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodosForGanttResponse.fromJS(resultData200);
            return Promise.resolve<GetTodosForGanttResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodosForGanttResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMany(body: DeleteTodosRequest | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/deleteMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMany(_response);
        });
    }

    protected processDeleteMany(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTodo(body: AddTodoRequest | undefined , cancelToken?: CancelToken | undefined): Promise<AddTodoResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/addTodo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTodo(_response);
        });
    }

    protected processAddTodo(response: AxiosResponse): Promise<AddTodoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTodoResponse.fromJS(resultData200);
            return Promise.resolve<AddTodoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTodoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTodo(body: UpdateTodoRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SuccessUpdateResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/updateTodo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTodo(_response);
        });
    }

    protected processUpdateTodo(response: AxiosResponse): Promise<SuccessUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 602) {
            const _responseText = response.data;
            let result602: any = null;
            let resultData602  = _responseText;
            result602 = TodoDTOConcurrencyResponse.fromJS(resultData602);
            return throwException("A server side error occurred.", status, _responseText, _headers, result602);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuccessUpdateResponse.fromJS(resultData200);
            return Promise.resolve<SuccessUpdateResponse>(result200);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * @param filename (optional) 
     * @param todoId (optional) 
     * @return Success
     */
    getSaveFileToken(filename: string | undefined, todoId: number | undefined , cancelToken?: CancelToken | undefined): Promise<AddTodoAttachmentResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/getSaveFileToken?";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "Filename=" + encodeURIComponent("" + filename) + "&";
        if (todoId === null)
            throw new Error("The parameter 'todoId' cannot be null.");
        else if (todoId !== undefined)
            url_ += "TodoId=" + encodeURIComponent("" + todoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaveFileToken(_response);
        });
    }

    protected processGetSaveFileToken(response: AxiosResponse): Promise<AddTodoAttachmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTodoAttachmentResponse.fromJS(resultData200);
            return Promise.resolve<AddTodoAttachmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTodoAttachmentResponse>(null as any);
    }

    /**
     * @param attachmentId (optional) 
     * @param escapeUri (optional) 
     * @return Success
     */
    getDownloadUri(attachmentId: number | undefined, escapeUri: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetTodoAttachmentDownloadLinkResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/getDownloadUri?";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "AttachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        if (escapeUri === null)
            throw new Error("The parameter 'escapeUri' cannot be null.");
        else if (escapeUri !== undefined)
            url_ += "EscapeUri=" + encodeURIComponent("" + escapeUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadUri(_response);
        });
    }

    protected processGetDownloadUri(response: AxiosResponse): Promise<GetTodoAttachmentDownloadLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoAttachmentDownloadLinkResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoAttachmentDownloadLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoAttachmentDownloadLinkResponse>(null as any);
    }

    /**
     * @param todoId (optional) 
     * @return Success
     */
    listAttachmentsTodoId(todoId: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetTodoAttachmentsListResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/listAttachmentsTodoId?";
        if (todoId === null)
            throw new Error("The parameter 'todoId' cannot be null.");
        else if (todoId !== undefined)
            url_ += "TodoId=" + encodeURIComponent("" + todoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAttachmentsTodoId(_response);
        });
    }

    protected processListAttachmentsTodoId(response: AxiosResponse): Promise<GetTodoAttachmentsListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoAttachmentsListResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoAttachmentsListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoAttachmentsListResponse>(null as any);
    }

    /**
     * @return Success
     */
    history(todoId: number , cancelToken?: CancelToken | undefined): Promise<GetTodoHistoryResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/history/{TodoId}";
        if (todoId === undefined || todoId === null)
            throw new Error("The parameter 'todoId' must be defined.");
        url_ = url_.replace("{TodoId}", encodeURIComponent("" + todoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: AxiosResponse): Promise<GetTodoHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTodoHistoryResponse.fromJS(resultData200);
            return Promise.resolve<GetTodoHistoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTodoHistoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    endUploadTodoAttachment(body: AddTodoAttachmentEndRequest | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/endUploadTodoAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEndUploadTodoAttachment(_response);
        });
    }

    protected processEndUploadTodoAttachment(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskPositions(body: UpdateTaskPositionsRequest | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/updateTaskPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTaskPositions(_response);
        });
    }

    protected processUpdateTaskPositions(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateKanban(body: UpdateTodoKanbanRequest | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/updateKanban";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateKanban(_response);
        });
    }

    protected processUpdateKanban(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param attachmentId (optional) 
     * @return Success
     */
    deleteAttachmentTodo(attachmentId: number | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/TodoMain/deleteAttachmentTodo?";
        if (attachmentId === null)
            throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "AttachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttachmentTodo(_response);
        });
    }

    protected processDeleteAttachmentTodo(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @return Success
     */
    usersResponsible(  cancelToken?: CancelToken | undefined): Promise<GetUsersForResponsibleResponse> {
        let url_ = this.baseUrl + "/api/UsersTodo/usersResponsible";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersResponsible(_response);
        });
    }

    protected processUsersResponsible(response: AxiosResponse): Promise<GetUsersForResponsibleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersForResponsibleResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersForResponsibleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersForResponsibleResponse>(null as any);
    }
}

export class AddTodoAttachmentEndRequest implements IAddTodoAttachmentEndRequest {
    attachmentId?: number;

    constructor(data?: IAddTodoAttachmentEndRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): AddTodoAttachmentEndRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoAttachmentEndRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface IAddTodoAttachmentEndRequest {
    attachmentId?: number;
}

export class AddTodoAttachmentResponse implements IAddTodoAttachmentResponse {
    link?: string | undefined;
    filename?: string | undefined;
    extension?: string | undefined;
    attachmentId?: number;

    constructor(data?: IAddTodoAttachmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.filename = _data["filename"];
            this.extension = _data["extension"];
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): AddTodoAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["filename"] = this.filename;
        data["extension"] = this.extension;
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface IAddTodoAttachmentResponse {
    link?: string | undefined;
    filename?: string | undefined;
    extension?: string | undefined;
    attachmentId?: number;
}

export class AddTodoRequest implements IAddTodoRequest {
    name?: string | undefined;
    responsibleId?: number | undefined;
    buildingId?: number | undefined;
    state?: TodoState;
    description?: string | undefined;
    start?: Date | undefined;
    leftMarker?: number | undefined;
    topMarker?: number | undefined;
    end?: Date | undefined;
    deadline?: Date | undefined;
    assignees?: number[] | undefined;
    markerColor?: string | undefined;
    applicationsId?: number | undefined;

    constructor(data?: IAddTodoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.responsibleId = _data["responsibleId"];
            this.buildingId = _data["buildingId"];
            this.state = _data["state"];
            this.description = _data["description"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.leftMarker = _data["leftMarker"];
            this.topMarker = _data["topMarker"];
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(item);
            }
            this.markerColor = _data["markerColor"];
            this.applicationsId = _data["applicationsId"];
        }
    }

    static fromJS(data: any): AddTodoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["responsibleId"] = this.responsibleId;
        data["buildingId"] = this.buildingId;
        data["state"] = this.state;
        data["description"] = this.description;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["leftMarker"] = this.leftMarker;
        data["topMarker"] = this.topMarker;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item);
        }
        data["markerColor"] = this.markerColor;
        data["applicationsId"] = this.applicationsId;
        return data;
    }
}

export interface IAddTodoRequest {
    name?: string | undefined;
    responsibleId?: number | undefined;
    buildingId?: number | undefined;
    state?: TodoState;
    description?: string | undefined;
    start?: Date | undefined;
    leftMarker?: number | undefined;
    topMarker?: number | undefined;
    end?: Date | undefined;
    deadline?: Date | undefined;
    assignees?: number[] | undefined;
    markerColor?: string | undefined;
    applicationsId?: number | undefined;
}

export class AddTodoResponse implements IAddTodoResponse {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: IAddTodoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AddTodoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddTodoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IAddTodoResponse {
    id?: number;
    rowVersion?: string | undefined;
}

export class DeleteTodoDTO implements IDeleteTodoDTO {
    id?: number;
    timestamp?: string | undefined;

    constructor(data?: IDeleteTodoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): DeleteTodoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IDeleteTodoDTO {
    id?: number;
    timestamp?: string | undefined;
}

export class DeleteTodosRequest implements IDeleteTodosRequest {
    selectedTodos?: DeleteTodoDTO[] | undefined;

    constructor(data?: IDeleteTodosRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedTodos"])) {
                this.selectedTodos = [] as any;
                for (let item of _data["selectedTodos"])
                    this.selectedTodos!.push(DeleteTodoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteTodosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTodosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedTodos)) {
            data["selectedTodos"] = [];
            for (let item of this.selectedTodos)
                data["selectedTodos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeleteTodosRequest {
    selectedTodos?: DeleteTodoDTO[] | undefined;
}

export class EmptyResponse implements IEmptyResponse {
    unit?: Unit;

    constructor(data?: IEmptyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmptyResponse {
    unit?: Unit;
}

export class GetTodoAttachmentDownloadLinkResponse implements IGetTodoAttachmentDownloadLinkResponse {
    link?: string | undefined;

    constructor(data?: IGetTodoAttachmentDownloadLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): GetTodoAttachmentDownloadLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoAttachmentDownloadLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        return data;
    }
}

export interface IGetTodoAttachmentDownloadLinkResponse {
    link?: string | undefined;
}

export class GetTodoAttachmentsListResponse implements IGetTodoAttachmentsListResponse {
    attachments?: TodoAttachmentDTO[] | undefined;

    constructor(data?: IGetTodoAttachmentsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(TodoAttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoAttachmentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoAttachmentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoAttachmentsListResponse {
    attachments?: TodoAttachmentDTO[] | undefined;
}

export class GetTodoHistoryResponse implements IGetTodoHistoryResponse {
    logs?: TodoHistoryDTO[] | undefined;
    stateChanges?: TodoStateChangeDTO[] | undefined;

    constructor(data?: IGetTodoHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(TodoHistoryDTO.fromJS(item));
            }
            if (Array.isArray(_data["stateChanges"])) {
                this.stateChanges = [] as any;
                for (let item of _data["stateChanges"])
                    this.stateChanges!.push(TodoStateChangeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodoHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodoHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.stateChanges)) {
            data["stateChanges"] = [];
            for (let item of this.stateChanges)
                data["stateChanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodoHistoryResponse {
    logs?: TodoHistoryDTO[] | undefined;
    stateChanges?: TodoStateChangeDTO[] | undefined;
}

export class GetTodosForGanttResponse implements IGetTodosForGanttResponse {
    todos?: TodoGanttDTO[] | undefined;

    constructor(data?: IGetTodosForGanttResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoGanttDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosForGanttResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosForGanttResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosForGanttResponse {
    todos?: TodoGanttDTO[] | undefined;
}

export class GetTodosResponse implements IGetTodosResponse {
    todos?: TodoDTO[] | undefined;

    constructor(data?: IGetTodosResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTodosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTodosResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTodosResponse {
    todos?: TodoDTO[] | undefined;
}

export class GetUsersForResponsibleResponse implements IGetUsersForResponsibleResponse {
    users?: UserResponsibleDTO[] | undefined;

    constructor(data?: IGetUsersForResponsibleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserResponsibleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersForResponsibleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersForResponsibleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersForResponsibleResponse {
    users?: UserResponsibleDTO[] | undefined;
}

export class HttpContent implements IHttpContent {
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method?: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method?: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version?: Version;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly properties?: { [key: string]: any; } | undefined;
    readonly options?: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.versionPolicy = _data["versionPolicy"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            if (_data["options"]) {
                (<any>this).options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (<any>(<any>this).options)![key] = _data["options"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["versionPolicy"] = this.versionPolicy;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (<any>data["options"])[key] = (<any>this.options)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version?: Version;
    versionPolicy?: HttpVersionPolicy;
    content?: HttpContent;
    method?: HttpMethod;
    requestUri?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    properties?: { [key: string]: any; } | undefined;
    options?: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version?: Version;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage;
    readonly isSuccessStatusCode?: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item.toJSON());
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version?: Version;
    content?: HttpContent;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage;
    isSuccessStatusCode?: boolean;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    Locked = 431,
    FailedDependency = 451,
    UpgradeRequired = 500,
    PreconditionRequired = 501,
    TooManyRequests = 502,
    RequestHeaderFieldsTooLarge = 503,
    UnavailableForLegalReasons = 504,
    InternalServerError = 505,
    NotImplemented = 506,
    BadGateway = 507,
    ServiceUnavailable = 508,
    GatewayTimeout = 510,
    HttpVersionNotSupported = 511,
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = 0,
    RequestVersionOrHigher = 1,
    RequestVersionExact = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class StringStringIEnumerableKeyValuePair implements IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IStringStringIEnumerableKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringIEnumerableKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringIEnumerableKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class SuccessUpdateResponse implements ISuccessUpdateResponse {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: ISuccessUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): SuccessUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuccessUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface ISuccessUpdateResponse {
    id?: number;
    rowVersion?: string | undefined;
}

export class TodoAttachmentDTO implements ITodoAttachmentDTO {
    id?: number;
    name?: string | undefined;
    extension?: string | undefined;
    rowVersion?: Date;

    constructor(data?: ITodoAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TodoAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITodoAttachmentDTO {
    id?: number;
    name?: string | undefined;
    extension?: string | undefined;
    rowVersion?: Date;
}

export class TodoDTO implements ITodoDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    assigneId?: number | undefined;
    assigneName?: string | undefined;
    creatorName?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    createdTime?: Date;
    deadline?: Date | undefined;
    state?: TodoState;
    stateString?: string | undefined;
    stateLocalizedString?: string | undefined;
    markerLeft?: number | undefined;
    markerTop?: number | undefined;
    color?: string | undefined;
    rowVersion?: string | undefined;
    assignees?: number[] | undefined;

    constructor(data?: ITodoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.assigneId = _data["assigneId"];
            this.assigneName = _data["assigneName"];
            this.creatorName = _data["creatorName"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.stateString = _data["stateString"];
            this.stateLocalizedString = _data["stateLocalizedString"];
            this.markerLeft = _data["markerLeft"];
            this.markerTop = _data["markerTop"];
            this.color = _data["color"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(item);
            }
        }
    }

    static fromJS(data: any): TodoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["assigneId"] = this.assigneId;
        data["assigneName"] = this.assigneName;
        data["creatorName"] = this.creatorName;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["stateString"] = this.stateString;
        data["stateLocalizedString"] = this.stateLocalizedString;
        data["markerLeft"] = this.markerLeft;
        data["markerTop"] = this.markerTop;
        data["color"] = this.color;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item);
        }
        return data;
    }
}

export interface ITodoDTO {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    assigneId?: number | undefined;
    assigneName?: string | undefined;
    creatorName?: string | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    createdTime?: Date;
    deadline?: Date | undefined;
    state?: TodoState;
    stateString?: string | undefined;
    stateLocalizedString?: string | undefined;
    markerLeft?: number | undefined;
    markerTop?: number | undefined;
    color?: string | undefined;
    rowVersion?: string | undefined;
    assignees?: number[] | undefined;
}

export class TodoDTOConcurrencyResponse implements ITodoDTOConcurrencyResponse {
    data?: TodoDTO;
    state?: UpdateResponseState;

    constructor(data?: ITodoDTOConcurrencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TodoDTO.fromJS(_data["data"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): TodoDTOConcurrencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TodoDTOConcurrencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface ITodoDTOConcurrencyResponse {
    data?: TodoDTO;
    state?: UpdateResponseState;
}

export class TodoGanttDTO implements ITodoGanttDTO {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    investorId?: number | undefined;
    investorName?: string | undefined;
    userIdFrom?: number;
    userIdFromName?: string | undefined;
    createdTime?: Date;
    deadline?: Date | undefined;
    duration?: number;
    progress?: number;
    state?: TodoState;
    level?: number;
    subtasks?: TodoGanttDTO[] | undefined;

    constructor(data?: ITodoGanttDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.userIdFrom = _data["userIdFrom"];
            this.userIdFromName = _data["userIdFromName"];
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.progress = _data["progress"];
            this.state = _data["state"];
            this.level = _data["level"];
            if (Array.isArray(_data["subtasks"])) {
                this.subtasks = [] as any;
                for (let item of _data["subtasks"])
                    this.subtasks!.push(TodoGanttDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodoGanttDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoGanttDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["userIdFrom"] = this.userIdFrom;
        data["userIdFromName"] = this.userIdFromName;
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["progress"] = this.progress;
        data["state"] = this.state;
        data["level"] = this.level;
        if (Array.isArray(this.subtasks)) {
            data["subtasks"] = [];
            for (let item of this.subtasks)
                data["subtasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITodoGanttDTO {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    buildingId?: number | undefined;
    buildingName?: string | undefined;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    investorId?: number | undefined;
    investorName?: string | undefined;
    userIdFrom?: number;
    userIdFromName?: string | undefined;
    createdTime?: Date;
    deadline?: Date | undefined;
    duration?: number;
    progress?: number;
    state?: TodoState;
    level?: number;
    subtasks?: TodoGanttDTO[] | undefined;
}

export class TodoHistoryDTO implements ITodoHistoryDTO {
    id?: number;
    idActor?: number;
    actor?: string | undefined;
    actorInits?: string | undefined;
    changeString?: string | undefined;
    propertyName?: string | undefined;
    originValue?: string | undefined;
    originValueString?: string | undefined;
    newValue?: string | undefined;
    newValueString?: string | undefined;
    execTime?: Date;

    constructor(data?: ITodoHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idActor = _data["idActor"];
            this.actor = _data["actor"];
            this.actorInits = _data["actorInits"];
            this.changeString = _data["changeString"];
            this.propertyName = _data["propertyName"];
            this.originValue = _data["originValue"];
            this.originValueString = _data["originValueString"];
            this.newValue = _data["newValue"];
            this.newValueString = _data["newValueString"];
            this.execTime = _data["execTime"] ? new Date(_data["execTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TodoHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idActor"] = this.idActor;
        data["actor"] = this.actor;
        data["actorInits"] = this.actorInits;
        data["changeString"] = this.changeString;
        data["propertyName"] = this.propertyName;
        data["originValue"] = this.originValue;
        data["originValueString"] = this.originValueString;
        data["newValue"] = this.newValue;
        data["newValueString"] = this.newValueString;
        data["execTime"] = this.execTime ? this.execTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITodoHistoryDTO {
    id?: number;
    idActor?: number;
    actor?: string | undefined;
    actorInits?: string | undefined;
    changeString?: string | undefined;
    propertyName?: string | undefined;
    originValue?: string | undefined;
    originValueString?: string | undefined;
    newValue?: string | undefined;
    newValueString?: string | undefined;
    execTime?: Date;
}

export enum TodoState {
    NEW = 0,
    ACTIVE = 1,
    RESOLVED = 2,
    CLOSED = 3,
}

export class TodoStateChangeDTO implements ITodoStateChangeDTO {
    idActor?: number;
    actor?: string | undefined;
    execTime?: Date;
    actualState?: TodoState;
    nextState?: TodoState;

    constructor(data?: ITodoStateChangeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idActor = _data["idActor"];
            this.actor = _data["actor"];
            this.execTime = _data["execTime"] ? new Date(_data["execTime"].toString()) : <any>undefined;
            this.actualState = _data["actualState"];
            this.nextState = _data["nextState"];
        }
    }

    static fromJS(data: any): TodoStateChangeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TodoStateChangeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActor"] = this.idActor;
        data["actor"] = this.actor;
        data["execTime"] = this.execTime ? this.execTime.toISOString() : <any>undefined;
        data["actualState"] = this.actualState;
        data["nextState"] = this.nextState;
        return data;
    }
}

export interface ITodoStateChangeDTO {
    idActor?: number;
    actor?: string | undefined;
    execTime?: Date;
    actualState?: TodoState;
    nextState?: TodoState;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export enum UpdateResponseState {
    OK = 0,
    DELETED = 1,
    UPDATED = 2,
}

export class UpdateTaskPositionsDTO implements IUpdateTaskPositionsDTO {
    taskId?: number;
    top?: number;
    left?: number;
    rowVersion?: string | undefined;

    constructor(data?: IUpdateTaskPositionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.top = _data["top"];
            this.left = _data["left"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdateTaskPositionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskPositionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["top"] = this.top;
        data["left"] = this.left;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdateTaskPositionsDTO {
    taskId?: number;
    top?: number;
    left?: number;
    rowVersion?: string | undefined;
}

export class UpdateTaskPositionsRequest implements IUpdateTaskPositionsRequest {
    positionsUpdates?: UpdateTaskPositionsDTO[] | undefined;

    constructor(data?: IUpdateTaskPositionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["positionsUpdates"])) {
                this.positionsUpdates = [] as any;
                for (let item of _data["positionsUpdates"])
                    this.positionsUpdates!.push(UpdateTaskPositionsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTaskPositionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskPositionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.positionsUpdates)) {
            data["positionsUpdates"] = [];
            for (let item of this.positionsUpdates)
                data["positionsUpdates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTaskPositionsRequest {
    positionsUpdates?: UpdateTaskPositionsDTO[] | undefined;
}

export class UpdateTodoKanbanDTO implements IUpdateTodoKanbanDTO {
    id?: number;
    assigneeId?: string | undefined;
    stateString?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IUpdateTodoKanbanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assigneeId = _data["assigneeId"];
            this.stateString = _data["stateString"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTodoKanbanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoKanbanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assigneeId"] = this.assigneeId;
        data["stateString"] = this.stateString;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateTodoKanbanDTO {
    id?: number;
    assigneeId?: string | undefined;
    stateString?: string | undefined;
    rowVersion?: Date;
}

export class UpdateTodoKanbanRequest implements IUpdateTodoKanbanRequest {
    updates?: UpdateTodoKanbanDTO[] | undefined;

    constructor(data?: IUpdateTodoKanbanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["updates"])) {
                this.updates = [] as any;
                for (let item of _data["updates"])
                    this.updates!.push(UpdateTodoKanbanDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTodoKanbanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoKanbanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item of this.updates)
                data["updates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTodoKanbanRequest {
    updates?: UpdateTodoKanbanDTO[] | undefined;
}

export class UpdateTodoRequest implements IUpdateTodoRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    markerColor?: string | undefined;
    responsibleId?: number | undefined;
    buildingId?: number | undefined;
    state?: TodoState;
    start?: Date | undefined;
    end?: Date | undefined;
    deadline?: Date | undefined;
    assignees?: number[] | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IUpdateTodoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.markerColor = _data["markerColor"];
            this.responsibleId = _data["responsibleId"];
            this.buildingId = _data["buildingId"];
            this.state = _data["state"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(item);
            }
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdateTodoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["markerColor"] = this.markerColor;
        data["responsibleId"] = this.responsibleId;
        data["buildingId"] = this.buildingId;
        data["state"] = this.state;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item);
        }
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdateTodoRequest {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    markerColor?: string | undefined;
    responsibleId?: number | undefined;
    buildingId?: number | undefined;
    state?: TodoState;
    start?: Date | undefined;
    end?: Date | undefined;
    deadline?: Date | undefined;
    assignees?: number[] | undefined;
    rowVersion?: string | undefined;
}

export class UserResponsibleDTO implements IUserResponsibleDTO {
    id?: number;
    label?: string | undefined;

    constructor(data?: IUserResponsibleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): UserResponsibleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponsibleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface IUserResponsibleDTO {
    id?: number;
    label?: string | undefined;
}

export class Version implements IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    readonly majorRevision?: number;
    readonly minorRevision?: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.build = _data["build"];
            this.revision = _data["revision"];
            (<any>this).majorRevision = _data["majorRevision"];
            (<any>this).minorRevision = _data["minorRevision"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        data["revision"] = this.revision;
        data["majorRevision"] = this.majorRevision;
        data["minorRevision"] = this.minorRevision;
        return data;
    }
}

export interface IVersion {
    major?: number;
    minor?: number;
    build?: number;
    revision?: number;
    majorRevision?: number;
    minorRevision?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}